function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { InfoPage, IconIllustrativeMessage } from '@blocket/blocket-ui';
import { actionCreators as blhActionCreators } from '../../reduxBits/blocketLoginHelper';
import { actionCreators as pleaseLoginActionCreators } from '../../reduxBits/pleaseLogin';

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    blhActions: bindActionCreators(blhActionCreators, dispatch),
    pleaseLoginActions: bindActionCreators(pleaseLoginActionCreators, dispatch)
  };
};

var PleaseLogin = function PleaseLogin(_ref) {
  var redirectUri = _ref.redirectUri,
      cancelUri = _ref.cancelUri,
      icon = _ref.icon,
      blhActions = _ref.blhActions,
      pleaseLoginActions = _ref.pleaseLoginActions,
      headline = _ref.headline,
      infoText = _ref.infoText,
      buttonText = _ref.buttonText,
      tag = _ref.tag,
      vendBranding = _ref.vendBranding;
  return /*#__PURE__*/React.createElement(InfoPage, _extends({
    icon: icon,
    headline: headline,
    infoText: infoText,
    buttonText: buttonText,
    buttonOnClick: function buttonOnClick() {
      pleaseLoginActions.clickedLoginButton();
      blhActions.goToLogin(redirectUri, cancelUri, tag);
    }
  }, vendBranding ? {
    vendInfo: true
  } : {
    schibstedInfo: true
  }));
};

PleaseLogin.propTypes = {
  icon: PropTypes.node,
  headline: PropTypes.string,
  infoText: PropTypes.string,
  redirectUri: PropTypes.string,
  cancelUri: PropTypes.string,
  blhActions: PropTypes.shape({
    goToLogin: PropTypes.func.isRequired
  }),
  pleaseLoginActions: PropTypes.shape({
    clickedLoginButton: PropTypes.func.isRequired
  }),
  tag: PropTypes.string,
  buttonText: PropTypes.string,
  vendBranding: PropTypes.bool
};
var defaultIcon = /*#__PURE__*/React.createElement(IconIllustrativeMessage, {
  width: 100,
  height: 100
});
PleaseLogin.defaultProps = {
  icon: defaultIcon,
  headline: 'Svara, skicka och ha koll',
  infoText: 'Alla dina meddelanden till köpare och säljare på ett och samma ställe.',
  buttonText: 'Logga in & kom igång!',
  vendBranding: false
};
export default connect(undefined, mapDispatchToProps)(PleaseLogin);
//# sourceMappingURL=PleaseLogin.js.map